import { NODE_DOMAIN, PHP_DOMAIN } from "../Domain";

export const CommonURLs = {
  GENERATE_TOKEN: `${PHP_DOMAIN}/api/users/generate-token.json`,
  ANALYSIS_FORM_SUBMIT: `${NODE_DOMAIN}/api/v1/email/clp`,
};
